import useTracksStore, {
  SOUND_EFFECTS_TRACK_ID,
  TrackType,
} from '../../../../../shared/store/tracks.store.tsx'
import useMediaStore from '../../../../../shared/store/media.store.tsx'
import { getAudioBufferFromAudioUrl } from '@/utils/get-audio-buffer-from-audio-url.ts'
import type {
  AudioFormClip,
  SoundEffectAsset,
} from '../../../../audio-form/data/dto/audio-form-input.ts'
import { mapAudioFormClipToClipPositions } from './map-audio-form-clip-to-clip-positions.ts'

export const mapSoundEffectLayerToClips = async (
  asset: SoundEffectAsset,
  clip: AudioFormClip
): Promise<void> => {
  // Load asset into media store
  const { addMedia } = useMediaStore.getState()
  if (!asset.uri) return

  // Load clip into tracks store
  const { addClip } = useTracksStore.getState()

  // todo: store file name and use it as id
  addClip(SOUND_EFFECTS_TRACK_ID, {
    id: crypto.randomUUID(),
    type: TrackType.SoundEffects,
    trackId: SOUND_EFFECTS_TRACK_ID,
    name: asset.soundEffectAlias,
    mediaId: asset.soundEffectAlias,
    src: asset.uri,
    ...mapAudioFormClipToClipPositions(clip, asset.duration ?? 0), // todo: fix this
  })

  const audioBuffer = await getAudioBufferFromAudioUrl(asset.uri)
  addMedia(asset.soundEffectAlias, audioBuffer)
}
